import React, { ReactNode } from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import { FormControlProps } from '../../schemed/FormControlProps';
import { useAutoSuggestionsStore } from './AutoSuggestionsStore';
import { useCopyText } from '../CopyText';

interface Props {
  value?: string | null;
  update: (v: string | null) => void;
  suggestionsKey: string;
  label: ReactNode;
}

export const AutoSuggestControl = (props: Props) => {
  const options = useAutoSuggestionsStore(x => x.options[props.suggestionsKey]) || [];

  
  if(!props.suggestionsKey) {
    return null;
  }

  return (
    <Autocomplete
      freeSolo
      value={props.value || null}
      onChange={(e, newValue) => {
        props.update(newValue || null);
      }}
      onInputChange={(e, newValue) => {
        if(e) {
          props.update(newValue || null);
          // data.update({ source_title: newValue || "" });
      }}}
      autoHighlight
      fullWidth
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          margin="none"
          label={props.label}
          />)}
      options={options}
      />
  );
}

export const AutoSuggest = (props: FormControlProps) => {
  return (
    <AutoSuggestControl
      suggestionsKey={props.extraProps?.suggestionsKey || ""}
      label={props.extraProps?.label || props.schema?.label}
      value={props.row[props.field]}
      update={v => props.onChange(props.row, { [props.field]: v })}
      />
  )
}



interface PropsMultiple {
  value?: string[] | null;
  update: (v: string[] | null) => void;
  suggestionsKey: string;
  label: ReactNode;
}

const Empty: string[] = [];

export const AutoSuggestMultipleControl = (props: PropsMultiple) => {
  const options = useAutoSuggestionsStore(x => x.options[props.suggestionsKey]) || [];

  const copyText = useCopyText();

  
  if(!props.suggestionsKey) {
    return null;
  }

  return (
    <Autocomplete
      freeSolo
      multiple
      value={props.value || Empty}
      onChange={(e, newValue) => {
        props.update(newValue || null);
      }}
      onInputChange={(e, newValue) => {
        if(e) {
          // props.update(newValue || null);
          // data.update({ source_title: newValue || "" });
      }}}
      autoHighlight
      fullWidth
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          margin="none"
          label={props.label}
          />)}
      options={options}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          return (
            <Chip
              size="small"
              {...getTagProps({ index })}
              key={option}
              label={option}
              onClick={(event) => {
                event.stopPropagation();
                copyText(option);
              }}
            />
          );
        })
      }
      />
  );
}

export const AutoSuggestMultiple = (props: FormControlProps) => {
  return (
    <AutoSuggestMultipleControl
      suggestionsKey={props.extraProps?.suggestionsKey || ""}
      label={props.extraProps?.label || props.schema?.label}
      value={props.row[props.field]}
      update={v => props.onChange(props.row, { [props.field]: v })}
      />
  )
}